import { gql } from "@apollo/client";

export const UPDATE_INCIDENT_NUMBER = gql`
  mutation updateCallInfo($input: UpdateCallInfoInput!) {
    updateCallInfo(input: $input) {
      errors
      clientMutationId
      incident {
        id
        uuid
        incidentNumber
      }
    }
  }
`;

export const UPDATE_CALL_TYPE = gql`
  mutation updateCallInfo($input: UpdateCallInfoInput!) {
    updateCallInfo(input: $input) {
      errors
      clientMutationId
      incident {
        classification {
          id
          name
          oriId
          position
        }
        id
        incidentNumber
        uuid
      }
    }
  }
`;

export const UPDATE_INCIDENT_PRIORITY = gql`
  mutation updateCallInfo($input: UpdateCallInfoInput!) {
    updateCallInfo(input: $input) {
      errors
      clientMutationId
      incident {
        incidentPriority {
          id
          name
          oriId
          position
        }
        id
        incidentNumber
        uuid
      }
    }
  }
`;

export const UPDATE_CALL_PRIORITY = gql`
  mutation updateCallInfo($input: UpdateCallInfoInput!) {
    updateCallInfo(input: $input) {
      errors
      clientMutationId
      incident {
        callPriority {
          id
          name
          oriId
          position
        }
        id
        incidentNumber
        uuid
      }
    }
  }
`;

export const UPDATE_CALL_ORIGIN = gql`
  mutation updateCallInfo($input: UpdateCallInfoInput!) {
    updateCallInfo(input: $input) {
      errors
      clientMutationId
      incident {
        incidentOrigin {
          id
          name
          oriId
          position
        }
        id
        incidentNumber
        uuid
      }
    }
  }
`;

export const UPDATE_CALL_TIME = gql`
  mutation updateCallInfo($input: UpdateCallInfoInput!) {
    updateCallInfo(input: $input) {
      errors
      clientMutationId
      incident {
        callTime
        id
        incidentNumber
        uuid
      }
    }
  }
`;

export const UPDATE_INCIDENT_ADDRESS = gql`
  mutation updateCallInfo($input: UpdateCallInfoInput!) {
    updateCallInfo(input: $input) {
      errors
      clientMutationId
      incident {
        id
        incidentNumber
        uuid
        address {
          city
          id
          lat
          lng
          name
          state
          streetName
          streetNumber
          unit
          zip
          validAddressAlerts {
            alertType {
              id
              name
              alertLevel
              oriId
              position
            }
            createdAt
            officer {
              deptAttribute {
                id
                badge
                ori {
                  id
                  abbreviation
                }
              }
              personalAttribute {
                id
                firstName
                lastName
              }
            }
            expireAt
            id
            notes
          }
        }
      }
    }
  }
`;

export const UPDATE_CALL_AREA = gql`
  mutation updateCallInfo($input: UpdateCallInfoInput!) {
    updateCallInfo(input: $input) {
      errors
      clientMutationId
      incident {
        id
        incidentNumber
        uuid
        area {
          id
          name
          oriId
          position
        }
      }
    }
  }
`;

export const UPDATE_CALL_TEAM = gql`
  mutation updateCallInfo($input: UpdateCallInfoInput!) {
    updateCallInfo(input: $input) {
      errors
      clientMutationId
      incident {
        id
        incidentNumber
        uuid
        team {
          id
          name
          oriId
          position
        }
      }
    }
  }
`;

export const UPDATE_ROLL_CALL = gql`
  mutation updateCallInfo($input: UpdateCallInfoInput!) {
    updateCallInfo(input: $input) {
      errors
      clientMutationId
      incident {
        id
        incidentNumber
        uuid
        rollCall
      }
    }
  }
`;

export const UPDATE_CALL_CANCELLED = gql`
  mutation updateCallInfo($input: UpdateCallInfoInput!) {
    updateCallInfo(input: $input) {
      errors
      clientMutationId
      incident {
        id
        incidentNumber
        uuid
        callCancelled
      }
    }
  }
`;

export const UPDATE_STATEWIDE_EVENTS = gql`
  mutation updateCallInfo($input: UpdateCallInfoInput!) {
    updateCallInfo(input: $input) {
      errors
      clientMutationId
      incident {
        id
        incidentNumber
        uuid
        stateWideEvents {
          id
          name
          oriId
          position
        }
      }
    }
  }
`;

export const UPDATE_DRUG_TYPES = gql`
  mutation updateCallInfo($input: UpdateCallInfoInput!) {
    updateCallInfo(input: $input) {
      errors
      clientMutationId
      incident {
        id
        incidentNumber
        uuid
        drugTypes {
          drugClassification {
            id
            name
            oriId
            position
          }
          id
          name
          oriId
          position
        }
      }
    }
  }
`;

export const UPDATE_INCIDENT_FLAGS = gql`
  mutation updateCallInfo($input: UpdateCallInfoInput!) {
    updateCallInfo(input: $input) {
      errors
      clientMutationId
      incident {
        id
        incidentNumber
        uuid
        incidentFlags {
          id
          name
        }
      }
    }
  }
`;

export const UPDATE_OPIATE_BLOCKER = gql`
  mutation updateCallInfo($input: UpdateCallInfoInput!) {
    updateCallInfo(input: $input) {
      errors
      clientMutationId
      incident {
        id
        incidentNumber
        uuid
        opiateBlocker
      }
    }
  }
`;

export const UPDATE_MENTAL_HEALTH = gql`
  mutation updateCallInfo($input: UpdateCallInfoInput!) {
    updateCallInfo(input: $input) {
      errors
      clientMutationId
      incident {
        id
        incidentNumber
        uuid
        mentalHealthRelated
      }
    }
  }
`;

export const UPDATE_DOMV = gql`
  mutation updateCallInfo($input: UpdateCallInfoInput!) {
    updateCallInfo(input: $input) {
      errors
      clientMutationId
      incident {
        id
        incidentNumber
        uuid
        domv
      }
    }
  }
`;

export const UPDATE_CARGO_THEFT = gql`
  mutation updateCallInfo($input: UpdateCallInfoInput!) {
    updateCallInfo(input: $input) {
      errors
      clientMutationId
      incident {
        id
        incidentNumber
        uuid
        cargoTheft
      }
    }
  }
`;

export const SET_NARRATIVES = gql`
  mutation setNarratives($input: SetNarrativesInput!) {
    setNarratives(input: $input) {
      errors
      narratives
      incidentUuid
    }
  }
`;
export const SET_QUERY_RETURNS = gql`
  mutation setQueryReturns($input: SetQueryReturnsInput!) {
    setQueryReturns(input: $input) {
      errors
      queryReturns
      incidentUuid
    }
  }
`;

export const UPDATE_EVERYTHING = gql`
  mutation updateCallInfo($input: UpdateCallInfoInput!) {
    updateCallInfo(input: $input) {
      errors
      clientMutationId
      incident {
        address {
          city
          id
          lat
          lng
          name
          state
          streetName
          streetNumber
          unit
          zip
          validAddressAlerts {
            alertType {
              id
              name
              alertLevel
              oriId
              position
            }
            expireAt
            createdAt
            officer {
              deptAttribute {
                id
                badge
                ori {
                  id
                  abbreviation
                }
              }
              personalAttribute {
                id
                firstName
                lastName
              }
            }
            id
            notes
          }
        }
        area {
          id
          name
          oriId
          position
        }
        callCancelled
        callTime
        cargoTheft
        classification {
          id
          name
          oriId
          position
        }
        commonCallType {
          id
          name
          oriId
          position
        }
        domv
        drugRelated
        drugTypes {
          drugClassification {
            id
            name
            oriId
            position
          }
          id
          name
          oriId
          position
        }
        employee {
          id
          deptAttribute {
            id
            ori {
              id
              oriName
              abbreviation
            }
          }
          personalAttribute {
            id
          }
        }
        inactive
        id
        incidentNumber
        incidentOrigin {
          id
          name
          oriId
          position
        }
        callPriority {
          id
          name
          oriId
          position
        }
        incidentPriority {
          id
          name
          oriId
          position
        }
        mentalHealthRelated
        narratives
        officerIncidentSpecifics {
          id
        }
        opiateBlocker
        ori {
          abbreviation
          agencyType
          id
          ori {
            id
            oriName
            abbreviation
            requireDrugType
            poldOptOut
          }
        }
        personIncidentSpecifics {
          id
          sealed
        }
        queryReturns
        rollCall

        team {
          id
          name
          oriId
          position
        }
        stateWideEvents {
          id
          name
          oriId
          position
        }
      }
    }
  }
`;
